import React, { useEffect, useState } from "react";
import {
    Container,
    Card,
    Table,
    Pagination,
} from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { getProject, deleteProject } from "../../store/slices/project";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";


export default function Projects() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [limit] = useState(20);
    const { projectList = {}, Loading } = useSelector((state) => state.projectlist);

    useEffect(() => {

        dispatch(getProject({ page, limit }));

    }, [dispatch])

    const [search, setSearch] = useState("");

    const rowsPerPage = 5;

    const projectData = projectList || [];

    const filteredUsers = projectData.filter(
        (project) =>
            project.projectName
                ?.toLowerCase()
                .includes(search.toLowerCase()) ||
            project.projectType
                ?.toLowerCase()
                .includes(search.toLowerCase())
    );

    const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);


    const paginatedUsers = filteredUsers.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
    );

    const buildPages = () =>
        Array.from({ length: totalPages }, (_, i) => i + 1);

    const handleEdit = (id) => {
        navigate(`/admin/project-edit/${id}`);
    };
    const viewSite = (id) => {
        navigate(`/admin/sites/${id}`);
    };

    const handleDelete = async (id) => {
        const confirmed = window.confirm(
            "Are you sure you want to delete this project?"
        );

        if (!confirmed) return;

        try {
            await dispatch(deleteProject(id)).unwrap();

            // Refresh the list
            dispatch(getProject({ page, limit }));

            toast.success("Project deleted successfully");
        } catch (error) {
            console.error(error?.message || error);
            toast.error("Failed to delete project");
        }
    };
    return (
        <>

            <div className="breadcrumb-bar mx-1" >
                <div className="container-fluid">
                    <div className="d-flex  flex-row align-items-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/admin/home" className="breadcrumb-link active">
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <span
                                className="breadcrumb-link inactive"

                            >
                                Projects
                            </span>
                        </div>

                        <button
                            className="add-outlet-btn"
                            onClick={() => navigate("/admin/project-add")}
                        >

                            Add Project
                        </button>

                    </div>
                </div>
            </div>


            <div className="ud-page-wrap">
                <Container fluid>
                    <div className="ud-header">
                        <h2 className="ud-main-title">Projects</h2>

                    </div>



                    {Loading ? (
                        <Card className="ud-table-card">
                            <Card.Body
                                className="d-flex justify-content-center align-items-center"
                                style={{ minHeight: "300px" }}
                            >
                                <div
                                    className="spinner-border text-primary"
                                    role="status"
                                    style={{
                                        width: "4rem",
                                        height: "4rem",
                                    }}
                                >
                                    <span className="visually-hidden">
                                        Loading...
                                    </span>
                                </div>
                            </Card.Body>
                        </Card>
                    ) : (
                        <Card className="ud-table-card">
                            <Card.Body className="p-0">
                                <div className="ud-scroll-wrap">
                                    <Table
                                        hover
                                        borderless
                                        className="ud-table align-middle mb-0"
                                    >
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Type</th>
                                                <th>Location</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {paginatedUsers.length > 0 ? (
                                                paginatedUsers.map((project, index) => (
                                                    <tr key={project._id}>
                                                        <td>
                                                            {(page - 1) * rowsPerPage +
                                                                index +
                                                                1}
                                                        </td>

                                                        <td>
                                                            <span className="awd-userid">
                                                                {project.projectName}
                                                            </span>
                                                        </td>

                                                        <td>{project.projectType} </td>

                                                        <td>{project?.location?.area}, {project?.location?.city} </td>

                                                        <td>
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent:
                                                                        "center",
                                                                    alignItems:
                                                                        "center",
                                                                    gap: "10px",
                                                                }}
                                                            >
                                                                <button className="editbtn"
                                                                    onClick={() =>
                                                                        handleEdit(
                                                                            project._id
                                                                        )
                                                                    }
                                                                    title="Edit"

                                                                >
                                                                    <FaEdit
                                                                        size={12}
                                                                    />
                                                                </button>

                                                                <button
                                                                    onClick={() =>
                                                                        handleDelete(
                                                                            project._id
                                                                        )
                                                                    }
                                                                    title="Delete"
                                                                    className="deletebtn"
                                                                >
                                                                    <FaTrash
                                                                        size={12}
                                                                    />
                                                                </button>
                                                                <button
                                                                    className="add-outlet-btn"
                                                                    onClick={() =>
                                                                        viewSite(
                                                                            project._id
                                                                        )
                                                                    }
                                                                >

                                                                    View Sites
                                                                </button>


                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan="5"
                                                        className="text-center py-4"
                                                    >
                                                        No Projects Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>
                    )}


                    <div className="ud-pagination-wrap">
                        <Pagination className="ud-pagination mb-0">
                            <Pagination.Prev
                                disabled={page === 1}
                                onClick={() => setPage(page - 1)}
                            />

                            {buildPages().map((p) => (
                                <Pagination.Item
                                    key={p}
                                    active={page === p}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </Pagination.Item>
                            ))}

                            <Pagination.Next
                                disabled={page === totalPages}
                                onClick={() => setPage(page + 1)}
                            />
                        </Pagination>
                    </div>
                </Container>
            </div>
        </>
    );
}